import React, { useEffect, useMemo, useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { message } from "antd";
import ReactLoading from "react-loading";
import { DatePicker, Input, Select } from "antd";
import { Skeleton } from "antd";
import moment from "moment";
import swal from "sweetalert";
import exportFromJSON from "export-from-json";
import {
  SearchOutlined,
  FilePdfOutlined,
  IdcardOutlined,
  FileWordOutlined,
  CheckOutlined,
  CopyOutlined,
  CalendarOutlined,
  DownOutlined,
  FileImageOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  FilterFilled,
  VideoCameraOutlined,
  UserOutlined,
  PlusOutlined,
  ExportOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import {
  Table,
  Modal,
  Tag,
  Button,
  Badge,
  Dropdown,
  Menu,
  Radio,
  Drawer,
  Card,
  Switch,
  Tooltip,
} from "antd";
import { Link, useHistory, useLocation } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import ContactCreator from "../Dashboard/FormContacts/ContactCreator";
import { calculateAgeFormDOB } from "../Documents/forms/Html/LeagleDocuments/forms/commonfunctions";
import useGetFile from "../../hooks/useGetFile";
import useAuthUserToken from "../../hooks/useAuthUserToken";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import useSearchContext from "../../hooks/useSearchContext";
import useUserId from "../../hooks/useUserId";
import InterviewRoundsIndicator from "../../components/components/InterviewRoundsIndicator";
import ReminderSection from "./components/ReminderSection";
import DashboardTabs from "./components/DashboardTabs";
import Timer from "./components/Timer";
import NotFitCandidate from "./components/NotFitCandidate";
import AdvanceFilters, {
  handleFilterDateClicks,
} from "./components/AdvanceFilters";
import DashboardLoader from "./components/DashboardLoader";
import { getAllLocations } from "../../services/locations/locations.service";
import { getAllUsers } from "../../services/users/users.service";
import {
  getAllFormTemplates,
  getAllFormTemplatesQualifications,
  getAllFormTemplatesSourceNames,
} from "../../services/formTemplates/formTemplates.service";
import {
  getAllDepartmentDesignationMapping,
  getAllDepartments,
  getAllDesignations,
} from "../../services/departments/departments.service";
import { checkBulkPermissions } from "../../utils/checkPermission";

function getVLevel(score) {
  if (score >= 71)
    return "V6"; // C1+ / C2
  else if (score >= 60)
    return "V5"; // C1
  else if (score >= 50)
    return "V4"; // B2
  else if (score >= 40)
    return "V3"; // B1
  else if (score >= 30)
    return "V2"; // A2
  else if (score >= 20)
    return "V1"; // A1
  else return "V1"; // Below CEFR A1
}

function subtractDays(noOfDays) {
  try {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - parseInt(noOfDays));

    if (isNaN(currentDate.getTime())) {
      throw new Error("Invalid date format provided");
    }

    return currentDate;
  } catch (e) {
    return {
      status: 500,
      message: "",
      error: e.message,
      candidateId: null,
    };
  }
}

const { Option } = Select;
const { RangePicker } = DatePicker;

let CACHE_DATA = {};
const INTERVIEW_ROUNDS = [
  {
    label: "L1",
    value: "L1",
  },
  {
    label: "L2",
    value: "L2",
  },
  {
    label: "L3",
    value: "L3",
  },
  {
    label: "L4",
    value: "L4",
  },
  {
    label: "L5",
    value: "L5",
  },
  {
    label: "L6",
    value: "L6",
  },
  {
    label: "L7",
    value: "L7",
  },
  {
    label: "L8",
    value: "L8",
  },
  {
    label: "L9",
    value: "L9",
  },
  {
    label: "L10",
    value: "L10",
  },
  {
    label: "Final",
    value: "final",
  },
  {
    label: "Versant",
    value: "versant",
  },
  {
    label: "Client Round",
    value: "clientRound",
  },
];

const VIDEXT = ["mp4"];
const IMGEXT = ["jpg", "jpeg", "png"];
const WORDEXT = ["doc", "docx"];

const CandidateDashboard = () => {
  const { userToken } = useAuthUserToken();
  const {
    search,
    setSearch,
    location,
    setLocation,
    formId,
    setFormId,
    trfId,
    setTrfId,
    setInterviewStatus,
    defaultDate,
    headerFilterStatus,
    setHeaderFilterStatus,
    setSelectedDatevalue,
    source,
    setSource,
    setQualification,
    qualification,
    callMasterId,
    setCallMasterId,
    setTalentPollCount,
    setHiredCount,
    setInProcessCount,
    setNewCount,
    setRejectedCount,
    setOnHoldount,
    candidateList,
    setCandidateList,
    recruiter,
    setRecruiter,
    positions,
    setPositions,
    advanceappliedFilters,
    setAdvanceappliedFilters,
    setNormalFilters,
    versantScore,
    setVersantScore,
    modeOfInterview,
    setModeOfInterview,
    filterFetched,
    subTabCount,
    setSubTabCount,
    dynamicRounds,
    setDynamicRounds,
    delaySubTabCount,
    setDelaySubTabCount,
    newCount,
    inProcessCount,
    frequency,
    setFrequency,
    interviewStatus,
    rotationalShift,
    setRotationalShift,
    interested,
    setInterested,
    current,
    setCurrent,
    setDefaultDate,
    unassigned,
    setUnassigned,
    isNavigateFromTrf,
    setTsNavigateFromTrf,
    jobType,
    setJobType,
    candidateType,
    setCandidateType,
    departmentId,
    setDepartmentId,
    designationId,
    setDesignationId,
    whatsAppCampaign,
    setWhatsAppCampaign,
    whatsAppResponse,
    setWhatsAppResponse,
    load,
    setLoad,
    documentation,
    setDocumentation,
    hirePage,
    setHirePage,
    rejectPage,
    setRejectPage,
    holdPage,
    setHoldPage,
    poolPage,
    setPoolPage,
    callType,
    setCallType,
  } = useSearchContext();

  const { imageLoad, getImage } = useGetFile(userToken);
  const api = useAxios();
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const TAB = searchParams.get("tab" || "");
  const userId = useUserId();
  const history = useHistory();
  const [interviewType, setInterviewType] = useState("");
  const [contactDelay, setContactDelay] = useState("");
  const [candidatesOrg, setCandidatesOrg] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [formNames, setFormNames] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [callMasters, setCallMasters] = useState([]);
  const [allTrfs, setAllTrfs] = useState([]);
  const [mapping, setMapping] = useState([]);
  const [allJobTypes, setAllJobTypes] = useState([]);
  const [allSources, setAllSources] = useState([]);
  const [allQualification, setAllQualification] = useState([]);
  const [allPositions, setAllPositions] = useState([]);
  const [statusParameters, setStatusParameters] = useState([]);
  const [reminders, setReminders] = useState({});
  const [candidate, setCandidate] = useState(null);
  const [logDate, setLogDate] = useState(moment().format("YYYY-MM-DD"));
  const [count, setCount] = useState({});
  const [record, setRecord] = useState(0);
  const [reminderPageNo, setReminderPageNo] = useState(1);
  const [index, setIndex] = useState(0);
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileCopyReminder, setMobileCopyReminder] = useState(-1);
  const [isAppliedFilterEnable, setIsAppliedFilterEnable] = useState(false);
  const [mobileCopy, setMobileCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [dataStatus, setDataStatus] = useState();
  const [visible, setVisible] = useState(false);
  const [tabLayout, setTabLayout] = useState("Application_Received");
  const [openRehireHistory, setOpenRehireHistory] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [notFitPopup, setNotFitPopup] = useState(false);
  const [interviewRouds, setInterviewRounds] = useState([...INTERVIEW_ROUNDS]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [canAddNew, setCanAddNew] = useState(false);
  const [canExport, setCanExport] = useState(false);
  const [canExportToAmeyo, setCanExportToAmeyo] = useState(false);
  const [canProceed, setCanProceed] = useState(false);
  const [canNotFit, setCanNotFit] = useState(false);
  const [canViewTotalWalkin, setCanViewTotalWalkin] = useState(false);
  const [canViewStatus, setCanViewStatus] = useState(false);
  const [isAmeyoActive, setIsAmeyoActive] = useState(true);
  const [walkInCountState, setWalkInCountState] = useState(0);
  const [repeatedWalkInCountState, setRepeatedWalkInCountState] = useState(0);
  const [freshWalkInCountState, setFreshWalkInCountState] = useState(0);
  const [ameyoCallPendingState, setAmeyoCallPendingState] = useState(0);
  const [ameyoCallCompletedState, setAmeyoCallCompletedState] = useState(0);

  useEffect(() => {
    const fetchPerms = async () => {
      const role = localStorage.getItem("user.role");
      if (!role) return;
      const checks = [
        { entityType: "application_module", permission: "add_new" },
        { entityType: "application_module", permission: "export" },
        { entityType: "application_module", permission: "export_to_ameyo" },
        { entityType: "application_module", permission: "application_proceed" },
        { entityType: "application_module", permission: "not_fit" },
        { entityType: "application_module", permission: "total_walkin" },
        { entityType: "application_module", permission: "status" },
      ];
      try {
        const results = await checkBulkPermissions(role, checks);
        const isAllowed = (perm) => results.find((r) => r.permission === perm)?.allowed || false;
        setCanAddNew(isAllowed("add_new"));
        setCanExport(isAllowed("export"));
        setCanExportToAmeyo(isAllowed("export_to_ameyo"));
        setCanProceed(isAllowed("application_proceed"));
        setCanNotFit(isAllowed("not_fit"));
        setCanViewTotalWalkin(isAllowed("total_walkin"));
        setCanViewStatus(isAllowed("status"));
      } catch (err) { console.log(err); }
    };
    fetchPerms();
  }, []);

  useEffect(() => {
    const fetchAmeyoStatus = async () => {
      try {
        const res = await api.get("/AmeyoServiceSettings", {
          tokenType: "user",
        });
        setIsAmeyoActive(res.data?.AmeyoServiceSettings?.isActive ?? true);
      } catch (err) {
        console.error("Ameyo status check failed in candidate dashboard:", err);
      }
    };
    fetchAmeyoStatus();
  }, []);

  const columns = [
    // {
    //   title: "S No.",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) =>
        moment(a.date, "DD/MM/YYYY").unix() -
        moment(b.date, "DD/MM/YYYY").unix(),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (candidate, record) => {
        if (candidate?.Name) {
          const isTestDone =
            candidate?.languageConfidenceScore &&
            candidate?.languageConfidenceScore?.status === 'completed';
          const languageData =
            candidate?.languageConfidenceScore?.overallScores || {};
          const _score = languageData["overall"]?.overall_score;
          const _gradeData = getVLevel(_score);
          return (
            <div className="w-100 d-flex justify-content-between">
              <span>{record?.candidate?.Name}</span>
              {isTestDone && (
                <span
                  className="px-2"
                  style={{
                    fontSize: "12px",
                    border: `1px solid rgb(82, 196, 26)`,
                    borderRadius: "10px",
                    color: "rgb(82, 196, 26)",
                    fontWeight: "700",
                  }}
                >
                  {_gradeData}
                </span>
              )}
            </div>
          );
        }
      },
    },
    {
      title: "Phone No",
      dataIndex: "phone",
      key: "phone",
      sorter: (a, b) => a?.phone?.localeCompare(b?.phone),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: (a, b) => a?.location?.localeCompare(b?.location),
    },
    // {
    //   title: "Source",
    //   dataIndex: "source",
    //   key: "source",
    //   sorter: (a, b) => a?.source?.localeCompare(b?.source),
    // },
    {
      title: "Qualification",
      dataIndex: "highest_qualification",
      key: "highest_qualification",
      sorter: (a, b) =>
        a?.highest_qualification?.localeCompare(b?.highest_qualification),
    },
    {
      title: "Experience",
      dataIndex: "experience",
      key: "experience",
      sorter: (a, b) => a?.experience?.localeCompare(b?.experience),
    },
    {
      title: "Position Applied",
      dataIndex: "applied_for",
      key: "applied_for",
      sorter: (a, b) => a?.applied_for?.localeCompare(b?.applied_for),
    },
    {
      title: "Schedule / Call Now",
      dataIndex: "schedule_call_now",
      key: "schedule_call_now",
      render: (text, record) => {
        if (text) {
          return (
            <div className="d-flex align-items-center gap-1">
              {record.isCallMeNow ? (
                <PhoneOutlined style={{ color: "#1890ff", fontSize: "16px", transform: "rotate(100deg)" }} />
              ) : (
                <CalendarOutlined style={{ color: "#1890ff", fontSize: "16px" }} />
              )}
              <span>{text}</span>
            </div>
          );
        }
        return "";
      },
    },
    {
      title: "Waiting Time",
      dataIndex: "waiting_time",
      key: "waiting_time",
      render: (val, record) => {
        if (
          record?.candidate?.walkInType === "Direct" &&
          record?.candidate?.waitingTime !== null
        ) {
          return <Timer record={record?.candidate} />;
        }
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (filePath, record) => {
        const { resumeFilePath, videoFilePath } = filePath;
        return (
          <div className="d-flex gap-1 justify-center">
            {resumeFilePath ? (
              <span style={{ display: "inline-block", width: "20px" }}>
                {resumeFilePath?.path?.split(".").pop()?.toLowerCase() ===
                  "pdf" && (
                    <span className="pdf-icon d-flex align-items-center justify-content-center">
                      <FilePdfOutlined
                        onClick={async (e) => {
                          const resumeUrl = `/doc/${encodeURIComponent(
                            resumeFilePath?.path,
                          )}`;
                          window.open(resumeUrl, "_blank");
                        }}
                        style={{ fontSize: "1.3rem" }}
                      />
                    </span>
                  )}
                {WORDEXT.includes(
                  resumeFilePath?.path?.split(".").pop()?.toLowerCase(),
                ) && (
                    <span className="word-icon d-flex align-items-center justify-content-center">
                      <FileWordOutlined
                        onClick={async (e) => {
                          const resumeUrl = `/doc/${encodeURIComponent(
                            resumeFilePath?.path,
                          )}`;
                          window.open(resumeUrl, "_blank");
                        }}
                        style={{ fontSize: "1.3rem" }}
                      />
                    </span>
                  )}
                {IMGEXT.includes(
                  resumeFilePath?.path?.split(".").pop()?.toLowerCase(),
                ) && (
                    <span className="img-icon d-flex align-items-center justify-content-center">
                      <FileImageOutlined
                        onClick={async (e) => {
                          const resumeUrl = `/doc/${encodeURIComponent(
                            resumeFilePath?.path,
                          )}`;
                          window.open(resumeUrl, "_blank");
                        }}
                        style={{ fontSize: "1.3rem" }}
                      />
                    </span>
                  )}
              </span>
            ) : (
              ""
            )}
            {videoFilePath ? (
              <span style={{ display: "inline-block", width: "20px" }}>
                {VIDEXT.includes(
                  videoFilePath?.path?.split(".").pop()?.toLowerCase(),
                ) && (
                    <span className="word-icon d-flex align-items-center justify-content-center">
                      <VideoCameraOutlined
                        onClick={async (e) => {
                          const videoUrl = `/doc/${encodeURIComponent(
                            videoFilePath?.path,
                          )}`;
                          window.open(videoUrl, "_blank");
                        }}
                        style={{ fontSize: "1.3rem" }}
                      />
                    </span>
                  )}
              </span>
            ) : (
              ""
            )}
            <span className="word-icon d-flex align-items-center justify-content-center">
              <IdcardOutlined
                style={{ fontSize: "1.3rem" }}
                onClick={() => {
                  setIsModalOpen(true);
                  getCandidate(record?.candidate, record?.key);
                }}
              />
            </span>
          </div>
        );
      },
    },
  ];

  const pages = {
    Application_Received: current,
    Hired: hirePage,
    "On Hold": holdPage,
    Rejected: rejectPage,
    TalentPool: poolPage,
  };

  const pageSetterMap = {
    Application_Received: setCurrent,
    "On Hold": setHoldPage,
    Hired: setHirePage,
    Rejected: setRejectPage,
    TalentPool: setPoolPage,
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const isApplicationReceived = headerFilterStatus === "Application_Received";

  const getProcesses = async () => {
    try {
      const res = await api.get("/processes", { tokenType: "user" });
      setProcesses(res.data.processes);
    } catch (err) {
      console.error(err);
    }
  };
  // const getPositions = async () => {
  //   try {
  //     const res = await api.get("/formtemplate/position", {
  //       tokenType: "user",
  //     });
  //     setAllPositions(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getDepartments = async () => {
    try {
      const { data } = await getAllDepartments(api, "user");
      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getDesignations = async () => {
    try {
      const { data } = await getAllDesignations(api, "user");
      const { designation } = data || {};
      setDesignations(designation?.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getUsers = async () => {
    try {
      const res = await getAllUsers(api, "user");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const getLocations = async () => {
    try {
      const res = await getAllLocations(api, "user");
      setLocations(res.data.locationMaster);
    } catch (err) {
      console.error(err);
    }
  };
  const getFormNames = async () => {
    try {
      const res = await getAllFormTemplates(api, "user");
      setFormNames(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const getStatusParametermaster = async () => {
    try {
      const res = await api.get("/statusParametersMaster", {
        tokenType: "user",
      });
      setStatusParameters([
        ...res.data?.filter((status) => status.name !== "Rejected"),
      ]);
    } catch (err) {
      console.error(err);
    }
  };
  const getAllTrfs = async () => {
    try {
      const res = await api.get(
        `/trf/approvedRejected?Department=&Location=&trfStatus=true&isTRFAssignable=`,
        {
          tokenType: "user",
        },
      );
      setAllTrfs(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const getAllJobTypes = async () => {
    try {
      const { data } = await api.get(`/jobtype`, {
        tokenType: "user",
      });
      setAllJobTypes(data?.jobType);
    } catch (err) {
      console.error(err);
    }
  };
  const getAllSources = async () => {
    try {
      const res = await getAllFormTemplatesSourceNames(api, "user");
      setAllSources([...res.data, "Chatbot"]);
    } catch (err) {
      console.error(err);
    }
  };
  const getAllQualifications = async () => {
    try {
      const res = await getAllFormTemplatesQualifications(api, "user");
      setAllQualification([...res.data]);
    } catch (err) {
      console.error(err);
    }
  };

  const getCallMaster = async () => {
    try {
      const res = await api.get(`/callMaster?`, {
        tokenType: "user",
      });
      const { callMaster } = res.data;
      setCallMasters([...callMaster]);
    } catch (err) {
      console.error(err);
    }
  };

  const getDepartmentDesignationMapping = async () => {
    try {
      const { data } = await getAllDepartmentDesignationMapping(api, "user");
      const { data: mapping } = data || {};
      setMapping(mapping?.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (search === "") {
      setHeaderFilterStatusHandler(TAB, pages[TAB]);
    }
    setTabLayout(TAB);
  }, [TAB]);

  useEffect(() => {
    if (search !== "") {
      if (TAB === "Application_Received") {
        const keysToCompare = ["Application_Received", "In_Process"];
        const maxKey = keysToCompare.reduce((a, b) =>
          frequency[a] > frequency[b] ? a : b,
        );
        setHeaderFilterStatus(maxKey);
      }
    }
  }, [TAB]);

  useEffect(() => {
    Promise.all([
      getProcesses(),
      getLocations(),
      getFormNames(),
      getStatusParametermaster(),
      getAllTrfs(),
      getAllJobTypes(),
      getAllSources(),
      getAllQualifications(),
      getCallMaster(),
      getUsers(),
      // getPositions(),
      getDepartments(),
      getDesignations(),
      getDepartmentDesignationMapping(),
    ]);
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      console.log(Object.keys(CACHE_DATA).length);
      for (const key in CACHE_DATA) {
        if (CACHE_DATA[key].expiry < Date.now()) {
          delete CACHE_DATA[key];
        }
      }
    }, 1000 * 5);

    return () => {
      clearTimeout(id);
    };
  }, []);

  useEffect(() => {
    if (headerFilterStatus === "Reminder" || search !== "") return;
    if (filterFetched) loadCandidates();
  }, [
    headerFilterStatus,
    current,
    hirePage,
    poolPage,
    rejectPage,
    holdPage,
    trigger,
    filterFetched,
  ]);

  const getReminders = async () => {
    try {
      setLoad(true);

      const startDate = defaultDate[0]
        ? defaultDate[0]?._i || moment(defaultDate[0]).format("YYYY-MM-DD")
        : isNavigateFromTrf
          ? ""
          : moment(new Date()).subtract(1, "month").format("YYYY-MM-DD");
      const endDate = defaultDate[1]
        ? defaultDate[1]?._i || moment(defaultDate[1]).format("YYYY-MM-DD")
        : isNavigateFromTrf
          ? ""
          : moment(new Date()).format("YYYY-MM-DD");

      const [ameyoRes, totalRes] = await Promise.all([
        api.get(`/interviews/ameyo/interviewLogs?PageNo=${reminderPageNo}&PageSize=10&logDate=${logDate}`, { tokenType: "user" }),
        api.get(`/interviews/ameyo/interviewLogs?PageNo=1&PageSize=1&StartDate=${startDate}&EndDate=${endDate}`, { tokenType: "user" })
      ]);

      const ameyoLogs = ameyoRes.data.interviewLogs || [];

      let arr = [...ameyoLogs];

      // Sort the array by date/time
      arr.sort((a, b) => {
        const timeA = new Date(a.callSchedule || a.slotDate).getTime();
        const timeB = new Date(b.callSchedule || b.slotDate).getTime();
        return timeA - timeB;
      });

      arr.forEach((reminder) => {
        const { files } = reminder?.candidateId || {};
        if (files?.length !== 0) {
          for (let file of files || []) {
            if (file.fieldname) {
              if (!reminder.filePath) reminder.filePath = {};
              if (file.fieldname.toLowerCase().indexOf("resume") !== -1) {
                reminder.filePath.resumeFilePath = file;
              }
              if (file.fieldname.toLowerCase().indexOf("video") !== -1) {
                reminder.filePath.videoFilePath = file;
              }
            }
          }
        }
      });

      const totalCount = totalRes?.data?.interviewLogsCount !== undefined
        ? totalRes.data.interviewLogsCount
        : (ameyoRes?.data?.interviewLogsCount || 0);
      const currentDayCount = ameyoRes?.data?.currentDayCount || 0;

      setReminders({
        interviewLogsCount: currentDayCount,
        totalRangeCount: totalCount,
        currentDayCount: currentDayCount,
        interviewLogs: arr,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (headerFilterStatus === "Reminder") {
      getReminders();
      setMobileCopyReminder(-1);
    }
  }, [headerFilterStatus, logDate, reminderPageNo, defaultDate]);

  const initialRender = useRef(false);
  const latestRequestIdRef = useRef(0);

  useEffect(() => {
    if (!initialRender.current) {
      initialRender.current = true;
      return;
    }
    const timeOut = setTimeout(async () => {
      if (contactDelay || interviewType || documentation) {
        setContactDelay("");
        setInterviewType("");
        setDocumentation("");
      }
      // Trigger API only if search is empty (reset) or length >= 3
      if (search === "" || search.length >= 3) {
        loadCandidates(1);
      }
      // Note: if 1 or 2 characters, we do nothing, so data doesn't change
    }, 500);

    return () => clearTimeout(timeOut);
  }, [search]);

  const getCandidate = async (candidate_, _index) => {
    console.log(candidate_, "KKKKKKKKKKKKKK");
    if (!candidate_?.id) return;
    setIndex(_index);
    setRecord(_index + 1 + 10 * (pages[TAB] - 1));
    setMobileCopy(false);
    setEmailCopy(false);
    try {
      setLoading(true);
      const url = `/candidates/rehireCandidates/${candidate_?.id}`;
      let candidate;
      if (CACHE_DATA[url]) {
        candidate = CACHE_DATA[url].data;
      } else {
        const res = await api.get(url, {
          tokenType: "user",
        });
        candidate = res?.data;
        CACHE_DATA[url] = {
          data: res.data,
          expiry: Date.now() + 10 * 1000,
        };
      }

      let resumeFilePath = "";
      let videoFilePath = "";
      const { files } = candidate;

      if (files && files?.length !== 0) {
        for (let file of files) {
          if (file.fieldname) {
            if (file.fieldname.toLowerCase().indexOf("resume") !== -1) {
              resumeFilePath = file;
            }
          }
          if (file.fieldname) {
            if (file.fieldname.toLowerCase().indexOf("video") !== -1) {
              videoFilePath = file;
            }
          }
        }
      }
      const { totalInterviews, interviewData } = candidate;

      const dept = candidate_.personalDetails["Job Profile Applying For"]
        ? candidate_.personalDetails["Job Profile Applying For"]?.split("-")[0]
        : "" || candidate_?.personalDetails["Select Department"] || "";
      const desg = candidate_.personalDetails["Job Profile Applying For"]
        ? candidate_.personalDetails["Job Profile Applying For"]?.split("-")[1]
        : "" || candidate_?.personalDetails["Select Designation"] || "";
      const deptDesg =
        dept || desg ? `${dept || ""}${desg ? ` / ${desg}` : ""}` : "";

      const voiceBot = candidate_?.voiceBotData?.latest || candidate_?.voiceBotData;

      const noticePeriod = candidate_?.personalDetails["Notice period"];
      const ctc = candidate_?.personalDetails["Current CTC ( In LPA only )"];
      const dob = candidate_?.personalDetails["Date of Birth"];
      let lang =
        candidate_?.personalDetails["Languages Known"] ||
        (voiceBot?.["English_and_Hindi"]
          ? [voiceBot?.["English_and_Hindi"]]
          : []);
      if (Array.isArray(lang)) {
        lang = lang.map(item => {
          if (typeof item === 'string' && item.toLowerCase() === 'yes') {
            return 'English, Hindi';
          }
          return item;
        });
      } else if (typeof lang === 'string' && lang.toLowerCase() === 'yes') {
        lang = 'English, Hindi';
      }
      const exp = candidate_?.personalDetails["Total Experience"];
      const loc =
        candidate_?.personalDetails["Preferred Location"] ||
        candidate_?.location ||
        voiceBot?.["wfo_preferred_location"] ||
        voiceBot?.["wfh_preferred_location"] ||
        "";
      const isNonAgent = candidate_?.["Position Applied"] === "Non Agent";
      const profile =
        candidate_["Position Applied"] === "Non Agent"
          ? candidate_.FormId
            ? deptDesg
            : ""
          : candidate_["Position Applied"] === "Agent"
            ? deptDesg
            : "";
      const qual =
        candidate_?.personalDetails["Highest Qualification"] ||
        candidate_?.personalDetails["Educational Qualifications"] ||
        voiceBot?.["qualification_extraction"] ||
        "";
      candidate.DOB = dob;
      candidate.age = dob ? `${calculateAgeFormDOB(dob)} Years` : "";
      candidate.languages = lang ? (Array.isArray(lang) ? lang.join(", ") : lang) : "";
      candidate.qualification = qual || "";
      candidate.experience = exp || "";
      candidate.preferred_location = loc || "";
      candidate.profile = profile;
      candidate.ctc = ctc || "";
      candidate.noticePeriod = noticePeriod ? noticePeriod : "";
      candidate.resume = resumeFilePath ? resumeFilePath : "Not Uploaded";
      candidate.video = videoFilePath ? videoFilePath : "Not Uploaded";
      candidate.isNonAgent = candidate?.trf?.candidateType === "Non-Agent";
      candidate.departmentDesignation = deptDesg || "";
      candidate.isNonAgent = isNonAgent;
      candidate.isDocumentSentToCandidate = candidate_?.isDocumentSent;

      let rounds = [];

      if (totalInterviews && interviewData) {
        if (candidate?.trf?.candidateType === "Non-Agent") {
          rounds = Array.from([...totalInterviews])
            ?.sort((a, b) => a.interviewNo - b.interviewNo)
            ?.map((item) => {
              const Founded = interviewData?.find(
                (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
              );
              return {
                name: item?.interviewNames?.[0]?.interviewNames,
                status: Founded ? Founded?.status : "",
              };
            });
        } else {
          const interviewRounds = {
            L1: "L1 Status",
            L2: "L2 Status",
            final: "Final Round",
            versant: "Versant Round",
            clientRound: "Client Round",
          };
          rounds = Object.keys(interviewRounds)?.map((item) => {
            const Founded = interviewData?.find((ele) => {
              if (item === 'final') {
                return ele?.type === 'final' || ele?.type === 'L4';
              }
              return item === ele?.type;
            });
            return {
              name: interviewRounds[item],
              status: Founded ? Founded?.status : "",
            };
          });
        }
      }

      candidate.rounds = rounds;

      setCandidate(candidate);
    } catch (err) {
      console.log(err);
      setCandidate({ ...candidate_, _id: candidate_?.id });
    } finally {
      setLoading(false);
    }
  };

  function getKeyWithHighestFrequency(obj) {
    let maxKey = null;
    let maxValue = -Infinity;

    for (const [key, value] of Object.entries(obj)) {
      if (value > maxValue) {
        maxValue = value;
        maxKey = key;
      }
    }
    return maxKey;
  }

  const generateTableData = (candidates) => {
    let data = [];
    let _frequency = {
      Hired: 0,
      TalentPool: 0,
      In_Process: 0,
      Application_Received: 0,
      Rejected: 0,
      "On Hold": 0,
    };

    let sub_frequency = {
      L1: 0,
      L2: 0,
      L3: 0,
      L4: 0,
      L5: 0,
      L6: 0,
      L7: 0,
      L8: 0,
      L9: 0,
      L10: 0,
      "Documentation Pending": 0,
    };

    let delay_frequency = {
      1: 0,
      2: 0,
      3: 0,
    };

    if (candidates?.length !== 0) {
      for (let i = 0; i < candidates?.length; i++) {
        let resumeFilePath = "";
        let videoFilePath = "";
        const {
          files,
          Call_Status,
          Call_Reason,
          Call_Reason2,
          interviewDetails,
          isTalentPoolActive,
        } = candidates[i];
        if (files && files?.length !== 0) {
          for (let file of files) {
            if (file.fieldname) {
              if (file.fieldname.toLowerCase().indexOf("resume") !== -1) {
                resumeFilePath = file;
              }
            }
            if (file.fieldname) {
              if (file.fieldname.toLowerCase().indexOf("video") !== -1) {
                videoFilePath = file;
              }
            }
          }
        }

        let scheduleCallNow = "";
        let isCallMeNow = false;
        const ameyo = candidates[i]?.ameyoData || {};
        const priority = ameyo.priority !== undefined && ameyo.priority !== null ? Number(ameyo.priority) : null;

        if (priority === 1) {
          isCallMeNow = true;
          scheduleCallNow = "call me now";
        } else if (priority === 2) {
          isCallMeNow = false;
          const slot = ameyo.slot !== undefined && ameyo.slot !== null ? Number(ameyo.slot) : null;
          const targetDate = ameyo.slotDate;
          if (targetDate) {
            const slotDate = moment(targetDate);
            let timeStr = "";
            if (slot === 1) {
              timeStr = "10 AM-12 PM";
            } else if (slot === 2) {
              timeStr = "12-2 PM";
            } else if (slot === 3) {
              timeStr = "2-4 PM";
            } else if (slot === 4) {
              timeStr = "4-6 PM";
            } else if (slot === 5) {
              timeStr = "6-7 PM";
            } else {
              timeStr = slotDate.format("h:mm A");
            }

            if (slotDate.isSame(moment(), 'day')) {
              scheduleCallNow = `Today ${timeStr}`;
            } else if (slotDate.isSame(moment().subtract(1, 'day'), 'day')) {
              scheduleCallNow = `Yesterday ${timeStr}`;
            } else if (slotDate.isSame(moment().add(1, 'day'), 'day')) {
              scheduleCallNow = `Tomorrow ${timeStr}`;
            } else {
              scheduleCallNow = `${slotDate.format("DD/MM/YYYY")} ${timeStr}`;
            }
          }
        }

        let tabType = "";
        let subTabType = "";

        if (search !== "") {
          const isHired = candidates[i]["Onboard Status"] === "Yes";
          const isAgent = candidates[i]["Position Applied"] === "Agent";


          let isTalentPool = isTalentPoolActive === true;
          let isOnHold = false;
          let isRejected = false;
          let isNew =
            interviewDetails?.length === 0 &&
            Call_Status === "" &&
            Call_Reason === "" &&
            Call_Reason2 === "";
          const isDocumentSent = candidates[i]?.isDocumentSent || false;
          if (isHired && isDocumentSent) {
            tabType = "Hired";
            _frequency["Hired"] = _frequency["Hired"] + 1;
          } else if (isDocumentSent && !isHired) {
            subTabType = "Documentation Pending";
            sub_frequency["Documentation Pending"] =
              sub_frequency["Documentation Pending"] + 1;
            tabType = "In_Process";
            _frequency["In_Process"] = _frequency["In_Process"] + 1;
          } else {
            if (Call_Reason === "Unsuccessful" && Call_Reason2 !== "") {
              if (
                [
                  "Follow Up-call back",
                  "Call Drop",
                  "Incomplete Call",
                  "Looking for WFH",
                ].includes(Call_Reason2)
              ) {
                isOnHold = true;
              } else if (
                [
                  "Wrong Number",
                  "Not Interested",
                  "Poor comm skills",
                  "Salary Dispute",
                  "Location/Distance Issue",
                ].includes(Call_Reason2)
              ) {
                isRejected = true;
              } else if (
                [
                  "Igzy",
                  "Kochiva",
                  "Knowmax",
                  "B2B",
                  "Abhay Foundation",
                  "Internship Query",
                  "Other Queries",
                ].includes(Call_Reason2)
              ) {
                isTalentPool = true;
              }
            } else {
              if (["Offer Rejected"].includes(Call_Reason)) {
                isRejected = true;
              }

              // Ameyo-style: Call_Reason (callStatusMasterId) directly
              // contains the status value instead of "Unsuccessful"
              if (
                [
                  "Call Drop",
                  "Incomplete Call",
                  "callback",
                ].includes(Call_Reason)
              ) {
                isOnHold = true;
              } else if (
                [
                  "Wrong Number",
                  "Not Interested",
                  "Invalid No",
                ].includes(Call_Reason)
              ) {
                isRejected = true;
              } else if (
                [
                  "Igzy",
                  "Kochiva",
                  "Knowmax",
                  "B2B",
                  "Abhay Foundation",
                  "Query Call",
                  "No Answer",
                  "Call Disconnected",
                  "Number Busy",
                  "Switch Off",
                  "Not Reachable",
                  "Incoming not available",
                  "Future Hiring",
                ].includes(Call_Reason)
              ) {
                isTalentPool = true;
              }

              if (
                Call_Status !== "" ||
                Call_Reason !== "" ||
                Call_Reason2 !== ""
              ) {
                if (
                  Call_Status === "Not connected" &&
                  [
                    "Call Disconnected",
                    "Busy",
                    "Switch Off",
                    "Not Reachable",
                    "Incoming not available",
                    "Future Hiring",
                  ].includes(Call_Reason)
                ) {
                  isTalentPool = true;
                } else if (
                  Call_Status === "Not connected" &&
                  ["Wrong Number", "Invalid No"].includes(Call_Reason)
                ) {
                  isRejected = true;
                }

              }
              for (let interview of interviewDetails) {
                if (
                  ["On Hold", "Not Visited", "No Answer", "Drop"].includes(
                    interview?.status,
                  )
                ) {
                  isOnHold = true;
                  break;
                }
                if (interview?.status === "Rejected") {
                  isRejected = true;
                  break;
                }
              }
            }

            if (isTalentPool) {
              tabType = "TalentPool";
              _frequency["TalentPool"] = _frequency["TalentPool"] + 1;
            } else if (isNew) {
              tabType = "Application_Received";
              _frequency["Application_Received"] =
                _frequency["Application_Received"] + 1;
            } else if (isRejected) {
              tabType = "Rejected";
              _frequency["Rejected"] = _frequency["Rejected"] + 1;
            } else if (isOnHold) {
              tabType = "On Hold";
              _frequency["On Hold"] = _frequency["On Hold"] + 1;
            } else {
              tabType = "In_Process";
              _frequency["In_Process"] = _frequency["In_Process"] + 1;
            }

            if (tabType === "Application_Received") {
              const oneDayStart = subtractDays(2);
              const oneDayEnd = subtractDays(1);
              const twoDayStart = subtractDays(4);
              const twoDayEnd = subtractDays(2);
              const threeDayEnd = subtractDays(3);
              const threeDayStart = new Date(defaultDate[0]?._i);
              const localDate = candidates[i].dateApplied;
              const [day, month, yearAndTime] = localDate.split("/");
              const [year, time] = yearAndTime.split(" ");
              const [hour, minute, second] = time.split(":").map(Number);

              const dateApplied = new Date(
                year,
                Number(month) - 1,
                day,
                hour,
                minute,
                second,
              );

              if (oneDayStart <= dateApplied && oneDayEnd >= dateApplied) {
                subTabType = "1";
                delay_frequency["1"] = delay_frequency["1"] + 1;
              } else if (
                twoDayStart <= dateApplied &&
                twoDayEnd >= dateApplied
              ) {
                subTabType = "2";
                delay_frequency["2"] = delay_frequency["2"] + 1;
              } else if (
                threeDayStart <= dateApplied &&
                threeDayEnd >= dateApplied
              ) {
                subTabType = "3";
                delay_frequency["3"] = delay_frequency["3"] + 1;
              }
            }

            if (tabType === "In_Process") {
              if (
                (Call_Status || Call_Reason || Call_Reason2) &&
                interviewDetails?.length === 0
              ) {
                subTabType = "L1";
                sub_frequency["L1"] = sub_frequency["L1"] + 1;
              }

              const sortedInterview = candidates[i]?.interviewDetails?.sort(
                (a, b) => {
                  const special = {
                    final: 3,
                    versant: 3,
                    clientRound: 4,
                  };

                  function getSortValue(val) {
                    if (special[val] !== undefined) {
                      return special[val];
                    }
                    let match = val.match(/^L(\d+)$/);
                    if (match) {
                      return Number(match[1]);
                    }
                    return Number.MAX_SAFE_INTEGER;
                  }
                  return getSortValue(a.type) - getSortValue(b.type);
                },
              );

              const interview = sortedInterview[sortedInterview.length - 1];

              if (interview?.type) {
                if (["versant", "final"].includes(interview.type)) {
                  if (interview.finished && !isDocumentSent && !isAgent) {
                    const type = `L4`;
                    subTabType = type;
                    sub_frequency[type] = sub_frequency[type] + 1;
                  } else if (
                    interview.finished &&
                    interview.type === "versant" &&
                    !isDocumentSent &&
                    isAgent
                  ) {
                    const type = `L4`;
                    subTabType = type;
                    sub_frequency[type] = sub_frequency[type] + 1;
                  } else {
                    subTabType = "L3";
                    sub_frequency["L3"] = sub_frequency["L3"] + 1;
                  }
                } else if (interview.type === "clientRound") {
                  if (interview.finished && !isAgent) {
                    subTabType = "L5";
                    sub_frequency["L5"] = sub_frequency["L5"] + 1;
                  } else {
                    subTabType = "L4";
                    sub_frequency["L4"] = sub_frequency["L4"] + 1;
                  }
                } else {
                  if (interview.finished) {
                    const type = `L${sortedInterview.length + 1}`;
                    subTabType = type;
                    sub_frequency[type] = sub_frequency[type] + 1;
                  } else {
                    subTabType = interview.type;
                    sub_frequency[interview.type] =
                      sub_frequency[interview.type] + 1;
                  }
                }
              }
            }
          }
        }

        const dept = candidates[i].personalDetails["Job Profile Applying For"]
          ? candidates[i].personalDetails["Job Profile Applying For"]?.split(
            "-",
          )[0]
          : "" || candidates[i]?.personalDetails["Select Department"] || "";
        const desg = candidates[i].personalDetails["Job Profile Applying For"]
          ? candidates[i].personalDetails["Job Profile Applying For"]?.split(
            "-",
          )[1]
          : "" || candidates[i]?.personalDetails["Select Designation"] || "";
        const deptDesg =
          dept || desg ? `${dept || ""}${desg ? ` - ${desg}` : ""}` : "";

        data.push({
          key: candidates[i].id,
          date:
            // Object.keys(candidates[i]["personalDetails"]).length === 0 ? (
            //   <Badge.Ribbon text="Bulk" color="green" placement="start">
            //     <span>{convertTimeformat(candidates[i]["dateApplied"])}</span>
            //   </Badge.Ribbon>
            // ) : (
            convertTimeformat(candidates[i]["dateApplied"]),
          // ),
          name: candidates[i],
          applied_for:
            candidates[i]?.["Position Applied"] === "Non Agent"
              ? candidates[i]?.FormId
                ? deptDesg
                : ""
              : candidates[i]?.["Position Applied"] === "Agent"
                ? deptDesg
                : "",
          phone: candidates[i]?.["Phone Number"],
          experience:
            candidates[i]?.["personalDetails"]?.["Total Experience"] || "",
          // source:
          //   candidates[i]["personalDetails"][
          //     "How did you come to know about us"
          //   ] ||
          //   candidates[i].source ||
          //   "",
          id: candidates[i].id,
          candidate: candidates[i],
          highest_qualification:
            candidates[i]?.["personalDetails"]?.["Highest Qualification"] ||
            candidates[i]?.["personalDetails"]?.[
            "Educational Qualifications"
            ] ||
            candidates[i]?.["voiceBotData"]?.["qualification_extraction"] ||
            candidates[i]?.["voiceBotData"]?.["latest"]?.["qualification_extraction"] ||
            "",
          location:
            candidates[i]?.["personalDetails"]?.["Preferred Location"] ||
            candidates[i].location ||
            candidates[i]?.["voiceBotData"]?.["wfo_preferred_location"] ||
            candidates[i]?.["voiceBotData"]?.["wfh_preferred_location"] ||
            candidates[i]?.["voiceBotData"]?.["latest"]?.["wfo_preferred_location"] ||
            candidates[i]?.["voiceBotData"]?.["latest"]?.["wfh_preferred_location"] ||
            "",
          tabType,
          subTabType,
          schedule_call_now: scheduleCallNow,
          isCallMeNow,
          action: { videoFilePath, resumeFilePath },
          i,
        });
      }
    }

    setTalentPollCount(_frequency.TalentPool);
    setHiredCount(_frequency.Hired);
    setInProcessCount(_frequency.In_Process);
    setNewCount(_frequency.Application_Received);
    setRejectedCount(_frequency.Rejected);
    setOnHoldount(_frequency["On Hold"]);
    setFrequency(_frequency);
    setSubTabCount(sub_frequency);
    setDelaySubTabCount(delay_frequency);

    // if (
    //   search.length >= 3 &&
    //   !Object.values(delay_frequency).every((value) => value === 0)
    // ) {
    //   const key = getKeyWithHighestFrequency(delay_frequency);
    //   setContactDelay(key);
    // }

    // if (
    //   search.length >= 3 &&
    //   !Object.values(sub_frequency).every((value) => value === 0)
    // ) {
    //   const key = getKeyWithHighestFrequency(sub_frequency);
    //   setInterviewType(key);
    // }

    if (
      search.length >= 3 &&
      !Object.values(_frequency).every((value) => value === 0)
    ) {
      const key = getKeyWithHighestFrequency(_frequency);
      setHeaderFilterStatus(key);

      const tabUrl = ["In_Process", "Application_Received"].includes(key)
        ? "Application_Received"
        : key;
      history.push(`/candidate_dashboard?tab=${tabUrl}`);
    }
    return data;
  };

  useEffect(() => {
    if (search.length >= 3) {
      setCount({
        ...count,
        totalCount:
          frequency[
          tabLayout === "Application_Received"
            ? headerFilterStatus
            : tabLayout
          ],
      });
    }
  }, [headerFilterStatus, tabLayout, frequency, search]);

  useEffect(() => {
    const isTrueExist = Array.isArray(formId) && formId.includes(true);
    setUnassigned(isTrueExist);
  }, [formId]);

  const filtered = Array.isArray(formId)
    ? formId.filter((e) => e !== true)
    : [];

  async function loadCandidates(page = 0) {
    const requestId = ++latestRequestIdRef.current;
    try {
      const callTypeParam = [];
      const slotNoParam = [];

      (callType || []).forEach(val => {
        if (val === "Call Me Now") {
          callTypeParam.push("call me now");
        } else {
          const num = parseInt(val, 10);
          if (!isNaN(num)) {
            slotNoParam.push(num);
            if (!callTypeParam.includes("schedule call")) {
              callTypeParam.push("schedule call");
            }
          }
        }
      });

      const url = `candidates/Pagination?FormId=${JSON.stringify(
        filtered,
      )}&PageSize=10&PageNo=${page ? page : pages[TAB]
        }&Search=${search}&Position=${JSON.stringify(location)}&ProcessId=${localStorage.getItem("selectProcess")
          ? localStorage.getItem("selectProcess")
          : ""
        }&Status=${TAB === "Application_Received"
          ? headerFilterStatus === "Application_Received"
            ? ""
            : headerFilterStatus
          : TAB
        }&StartDate=${defaultDate[0]
          ? defaultDate[0]?._i
          : isNavigateFromTrf
            ? ""
            : moment(new Date()).subtract(1, "month").format("YYYY-MM-DD")
        }&EndDate=${defaultDate[1]
          ? defaultDate[1]?._i
          : isNavigateFromTrf
            ? ""
            : moment(new Date()).format("YYYY-MM-DD")
        }&ScoreType=${localStorage.getItem("selectScore")
          ? localStorage.getItem("selectScore")
          : ""
        }&InterviewType=${headerFilterStatus === "Application_Received"
          ? "Application_Received"
          : headerFilterStatus === "In_Process"
            ? search === ""
              ? interviewType
              : ""
            : ""
        }&Source=${JSON.stringify(source)}&Recruiter=${JSON.stringify(
          recruiter,
        )}&CandidateRole=${JSON.stringify(positions)}&TRF=${trfId}&departmentId=${JSON.stringify(departmentId)}&designationId=${JSON.stringify(designationId)}&isWhatsAppTrigger=${whatsAppCampaign}&whatsAppResponse=${whatsAppResponse}&onBoardProcess=${documentation}&TabType=${search === ""
          ? TAB === "Application_Received"
            ? headerFilterStatus
            : TAB
          : ""
        }&Designation=${localStorage.getItem("designation")
          ? localStorage.getItem("designation")
          : ""
        }&Qualification=${JSON.stringify(qualification)}&Versant=${JSON.stringify(
          versantScore,
        )}&CallStatus=${callMasterId}&contactDelay=${headerFilterStatus === "Application_Received"
          ? search === ""
            ? contactDelay
            : ""
          : ""
        }&modeofInterview=${modeOfInterview}&Interested=${JSON.stringify(
          interested,
        )}&Unassigned=${isApplicationReceived ? unassigned : false
        }&RotationalShift=${JSON.stringify(
          rotationalShift,
        )}&jobType=${JSON.stringify(jobType)}&candidateType=${JSON.stringify(
          candidateType,
        )}&callType=${JSON.stringify(callTypeParam)}&slotNo=${JSON.stringify(slotNoParam)}&RequestType="App"`;

      setLoad(true);

      const res = await api.get(url, { tokenType: "user" });

      if (requestId !== latestRequestIdRef.current) {
        return;
      }

      const {
        candidates,
        candidateCount,
        oneDayCount,
        twoDayCount,
        threeDayPlusCount,
        interviewCount,
        documentCount,
        walkInCount,
        repeatedWalkInCount,
        freshWalkInCount,
        ameyoCallPending,
        ameyoCallCompleted,
      } = res?.data;

      setWalkInCountState(walkInCount || 0);
      setRepeatedWalkInCountState(repeatedWalkInCount || 0);
      setFreshWalkInCountState(freshWalkInCount ?? ((walkInCount || 0) - (repeatedWalkInCount || 0)));
      setAmeyoCallPendingState(ameyoCallPending || 0);
      setAmeyoCallCompletedState(ameyoCallCompleted || 0);
      // candidates.sort(
      //   (a, b) =>
      //     moment(a.waitingTime, "DD/MM/YYYY HH:mm:ss").valueOf() -
      //     moment(b.waitingTime, "DD/MM/YYYY HH:mm:ss").valueOf()
      // );

      let counts = interviewCount[0] || {};
      const rounds = Object.keys(interviewCount[0] || {});

      if (rounds.length !== 0) {
        const sorted = rounds.sort((a, b) => {
          if (a === "Documentation Pending") return 1;
          if (b === "Documentation Pending") return -1;

          const numA = parseInt(a.replace(/\D/g, ""), 10);
          const numB = parseInt(b.replace(/\D/g, ""), 10);

          return numA - numB;
        });
        if (documentCount > 0) {
          sorted.push("Documentation");
        }
        setDynamicRounds(sorted);
      }

      const subCounts = {
        ...counts,
        totalCount: candidateCount || 0,
        oneDayCount: oneDayCount || 0,
        twoDayCount: twoDayCount || 0,
        threeDayPlusCount: threeDayPlusCount || 0,
        Documentation: documentCount,
      };

      setCount(subCounts);

      const formatData = generateTableData(candidates);
      setCandidateList(formatData);
      setCandidatesOrg([...candidates]);
    } catch (e) {
      console.log(e);
    } finally {
      if (requestId === latestRequestIdRef.current) {
        setLoad(false);
      }
    }
  }

  const clearFilters = async () => {
    setVersantScore([]);
    setDepartmentId([]);
    setDesignationId([]);
    setWhatsAppCampaign("");
    setWhatsAppResponse("");
    setLocation([]);
    setNormalFilters(0);
    setPositions([]);
    setFormId([]);
    setQualification([]);
    setInterviewStatus("");
    setTrfId("");
    setDocumentation("");
    setSource([]);
    setRecruiter([]);
    setCallMasterId("");
    setSelectedDatevalue("Last 30 Days");
    setDefaultDate(handleFilterDateClicks("Last 30 Days"));
    setModeOfInterview("");
    setInterested([]);
    setRotationalShift([]);
    setJobType([]);
    setCandidateType([]);
    setCallType([]);
    setUnassigned(false);
    setTsNavigateFromTrf(false);
    setCurrent(1);
    setHirePage(1);
    setHoldPage(1);
    setRejectPage(1);
    setPoolPage(1);
  };

  const onChange = (page) => {
    const setter = pageSetterMap[TAB];
    if (setter) {
      setter(page);
    }
  };

  function accepted(_id) {
    history.push("/candidate/" + _id + `?tab=${TAB}`);
  }

  const downloadReport = async () => {
    try {
      const callTypeParam = [];
      const slotNoParam = [];

      (callType || []).forEach(val => {
        if (val === "Call Me Now") {
          callTypeParam.push("call me now");
        } else {
          const num = parseInt(val, 10);
          if (!isNaN(num)) {
            slotNoParam.push(num);
            if (!callTypeParam.includes("schedule call")) {
              callTypeParam.push("schedule call");
            }
          }
        }
      });

      setLoad(true);
      const res = await api.get(
        `candidates/DownloadCSVAllCandidate?FormId=${JSON.stringify(
          filtered,
        )}&Search=${search}&Position=${[JSON.stringify(location)]}&ProcessId=${localStorage.getItem("selectProcess")
          ? localStorage.getItem("selectProcess")
          : ""
        }&Status=${TAB === "Application_Received"
          ? headerFilterStatus === "Application_Received"
            ? ""
            : headerFilterStatus
          : TAB
        }&StartDate=${defaultDate[0]
          ? defaultDate[0]?._i
          : isNavigateFromTrf
            ? ""
            : moment(new Date()).subtract(1, "month").format("YYYY-MM-DD")
        }&EndDate=${defaultDate[1]
          ? defaultDate[1]?._i
          : isNavigateFromTrf
            ? ""
            : moment(new Date()).format("YYYY-MM-DD")
        }&ScoreType=${localStorage.getItem("selectScore")
          ? localStorage.getItem("selectScore")
          : ""
        }&InterviewType=${headerFilterStatus === "Application_Received"
          ? "Application_Received"
          : headerFilterStatus === "In_Process"
            ? search === ""
              ? interviewType
              : ""
            : ""
        }&Unassigned=${isApplicationReceived ? unassigned : false
        }&Source=${JSON.stringify(source)}&Recruiter=${JSON.stringify(
          recruiter,
        )}&CandidateRole=${JSON.stringify(
          positions,
        )}&Qualification=${JSON.stringify(
          qualification,
        )}&TRF=${trfId}&departmentId=${JSON.stringify(departmentId)}&designationId=${JSON.stringify(designationId)}&isWhatsAppTrigger=${whatsAppCampaign}&whatsAppResponse=${whatsAppResponse}&onBoardProcess=${documentation}&Designation=${localStorage.getItem("designation")
          ? localStorage.getItem("designation")
          : ""
        }&userId=${userId}&TabType=${search === ""
          ? TAB === "Application_Received"
            ? headerFilterStatus
            : TAB
          : ""
        }&Versant=${JSON.stringify(
          versantScore,
        )}&CallStatus=${callMasterId}&contactDelay=${headerFilterStatus === "Application_Received"
          ? search === ""
            ? contactDelay
            : ""
          : ""
        }&modeofInterview=${modeOfInterview}&Interested=${JSON.stringify(
          interested,
        )}&RotationalShift=${JSON.stringify(
          rotationalShift,
        )}&jobType=${JSON.stringify(jobType)}&candidateType=${JSON.stringify(
          candidateType,
        )}&callType=${JSON.stringify(callTypeParam)}&slotNo=${JSON.stringify(slotNoParam)}&RequestType="App"`,
        { tokenType: "user" },
      );

      const { candidates } = res?.data;
      setLoad(false);
      return candidates;
    } catch (e) {
      setLoad(false);
      console.log(e);
    }
  };

  const exportToAmeyo = async () => {

    if (!selectedRows || selectedRows.length === 0) {
      message.warning("Please select at least one candidate.");
      return;
    }

    const mobileNumbers = selectedRows
      .map((row) => row.phone || row.candidate?.mobileNo)
      .filter((phone) => phone && phone.trim() !== "");

    if (mobileNumbers.length === 0) {
      message.warning("None of the selected candidates have a valid phone number.");
      return;
    }

    try {
      setLoad(true);
      const res = await api.post(
        "/ameyoDialer/push-contacts",
        { mobileNumbers },
        { tokenType: "user" }
      );

      if (res?.data?.success) {
        message.success(res.data.message || "Contacts successfully pushed to Ameyo.");
      } else {
        message.error(res?.data?.message || "Failed to push contacts to Ameyo.");
      }
    } catch (err) {
      console.error("Export to Ameyo error:", err);
      const errorMsg = err.response?.data?.message || err.message || "An error occurred.";
      message.error(errorMsg);
    } finally {
      setLoad(false);
    }
  };

  async function onClickDownloadCSV() {
    const candidateData = await downloadReport();
    let data = [];
    const exportType = "csv";

    const flattens = function (data) {
      var result = {};
      function sanitizeField(field) {
        return field.replace(/[^\w\s]/gi, "");
      }
      function recurse(cur, prop) {
        if (Object(cur) !== cur) {
          result[sanitizeField(prop)] = cur;
        } else if (Array.isArray(cur)) {
          for (var i = 0, l = cur.length; i < l; i++)
            recurse(cur[i], sanitizeField(prop) + "[" + i + "]");
          if (l == 0) result[sanitizeField(prop)] = [];
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], sanitizeField(p));
          }
          if (isEmpty && prop) result[sanitizeField(prop)] = {};
        }
      }
      recurse(data, "");
      return result;
    };

    data =
      candidateData &&
      candidateData.map((el) => {
        if (el.personalDetails["Preferred Location"]) {
          el.personalDetails["Preferred Location"] =
            el.personalDetails["Preferred Location"].toString();
        }
        if (
          el.personalDetails[
          "Select your working days (weekends are mandatory)"
          ]
        ) {
          el.personalDetails[
            "Select your working days (weekends are mandatory)"
          ] =
            el.personalDetails[
              "Select your working days (weekends are mandatory)"
            ].toString();
        }

        if (
          el.personalDetails[
          "Select your working days ( weekends are mandatory)"
          ]
        ) {
          el.personalDetails[
            "Select your working days ( weekends are mandatory)"
          ] =
            el.personalDetails[
              "Select your working days ( weekends are mandatory)"
            ].toString();
        }

        if (el.personalDetails["Type of Internet Connectivity"]) {
          el.personalDetails["Type of Internet Connectivity"] =
            el.personalDetails["Type of Internet Connectivity"].toString();
        }

        if (el.personalDetails["Type of system available"]) {
          el.personalDetails["Type of system available"] =
            el.personalDetails["Type of system available"].toString();
        }

        return flattens(el);
      });
    let fileName = `Candidates_${moment(new Date()).format(
      "DD-MM-YYYY_HH:mm",
    )}`;
    if (data && data?.length > 0 && !dataStatus) {
      exportFromJSON({ data, fileName, exportType });
    }
  }

  const checkCount = (_string) => {
    const Filters = [
      interviewStatus,
      trfId,
      whatsAppCampaign,
      whatsAppResponse,
      callMasterId,
      departmentId.length !== 0,
      designationId.length !== 0,
      formId.length !== 0,
      location.length !== 0,
      interested.length !== 0,
      rotationalShift.length !== 0,
      qualification.length !== 0,
      source.length !== 0,
      positions.length !== 0,
      versantScore.length !== 0,
      jobType.length !== 0,
      candidateType.length !== 0,
    ];

    if (_string !== "Application_Received") {
      Filters.push(recruiter.length !== 0);
      Filters.push(modeOfInterview);
    }

    const activeFilters = Filters.filter(Boolean).length;
    setAdvanceappliedFilters(activeFilters);
  };

  const setHeaderFilterStatusHandler = (_string, page) => {
    if (_string === "Application_Received") {
      setRecruiter([]);
      setDocumentation("");
      setModeOfInterview("");
      setInterviewType("");
      checkCount(_string);
      // setTrfId("");
      // setVersantScore([]);
      // setSource([]);
      // setAllSources((prevSources) => {
      //   const uniqueSources = new Map([
      //     ...prevSources.map((item) => [item, item]),
      //     ["BulkUpload", "BulkUpload"],
      //   ]);
      //   return [...uniqueSources.values()];
      // });
    } else {
      if (_string === "In_Process") {
        setContactDelay("");
      }
      // setCallMasterId("");
      if (_string === "Hired") {
        setInterviewRounds([
          ...interviewRouds.filter(
            (interview) => !["L1", "L2"].includes(interview.value),
          ),
        ]);
      } else {
        setInterviewRounds([...INTERVIEW_ROUNDS]);
      }
      // if (source === "BulkUpload") setSource("");
      // setAllSources([
      //   ...allSources.filter((source) => source !== "BulkUpload"),
      // ]);
    }
    // if (_string === "BulkUpload") {
    //   setSource("BulkUpload");
    // } else {
    //   setSource("");
    // }
    const setter = pageSetterMap[TAB];
    if (setter) {
      setter(page);
    }
    setReminderPageNo(1);
  };

  const convertTimeformat = (_date) => {
    const date = moment(_date, "DD/MM/YYYY H:m:s", true);
    if (date.isSame(moment(), "date")) {
      // return `Today ${date.format("hh:mm A")}`;
      return `Today`;
    }
    // return date.format("DD/MM/YYYY hh:mm A");
    return date.format("DD/MM/YY");
  };

  useEffect(() => {
    if (index + 1 >= 10 && record !== 0 && record < count?.totalCount) {
      setIndex(-1);
      const setter = pageSetterMap[TAB];
      if (setter) {
        setter(pages[TAB] + 1);
      }
    }
  }, [record]);

  useEffect(() => {
    if (index < 0 && record !== 0 && pages[TAB] !== 1) {
      setIndex(9);
      const setter = pageSetterMap[TAB];
      if (setter) {
        setter(pages[TAB] - 1);
      }
    }
  }, [record]);

  const Heading = {
    "On Hold": "On Hold",
    TalentPool: "Talent Pool",
    Application_Received: "All",
    Rejected: "Rejected",
    Hired: "Hired",
    In_Process: "In Process",
    Reminder: "Reminder",
    Reminder: "Reminder",
    BulkUpload: "Bulk Upload",
  };

  const getPagination = () => {
    if (TAB === "Application_Received") {
      let _count = 0;
      if (headerFilterStatus === "Application_Received") {
        if (contactDelay === "") {
          _count = count?.totalCount;
        } else if (contactDelay === "1") {
          _count = count?.oneDayCount;
        } else if (contactDelay === "2") {
          _count = count?.twoDayCount;
        } else if (contactDelay === "3") {
          _count = count?.threeDayPlusCount;
        }
      } else if (headerFilterStatus === "In_Process" && documentation) {
        if (documentation === "Documentation Pending") {
          _count = count?.["Documentation Pending"];
        }
      } else if (headerFilterStatus === "In_Process") {
        if (interviewType === "") {
          _count = count?.totalCount;
        } else if (interviewType === "L1") {
          _count = count?.L1;
        } else if (interviewType === "L2") {
          _count = count?.L2;
        } else if (interviewType === "L3") {
          _count = count?.L3;
        } else if (interviewType === "L4") {
          _count = count?.L4;
        } else if (interviewType === "L5") {
          _count = count?.L5;
        } else if (interviewType === "L6") {
          _count = count?.L6;
        } else if (interviewType === "L7") {
          _count = count?.L7;
        } else if (interviewType === "L8") {
          _count = count?.L8;
        }
      }
      return _count;
    } else {
      return count?.totalCount;
    }
  };

  const customFilter = (data) => {
    if (headerFilterStatus === "Application_Received") {
      return contactDelay === "" ? true : data.subTabType === contactDelay;
    } else if (headerFilterStatus === "In_Process") {
      if (documentation !== "") {
        return data.subTabType === documentation;
      }
      return interviewType === "" ? true : data.subTabType === interviewType;
    } else {
      return true;
    }
  };

  const isTrueExist = Array.isArray(formId) && formId.includes(true);

  return (
    <Dashboard title="Documents">
      {imageLoad && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}

      <div className="d-flex justify-content-between align-items-center py-1 mb-3">
        <h4 className="fw-normal">
          {Heading[headerFilterStatus]} Applications
        </h4>
        {headerFilterStatus !== "Reminder" && (
          <div className="d-flex gap-3">
            {isAmeyoActive && canViewTotalWalkin && (
              <Tooltip
                placement="top"
                overlayInnerStyle={{ whiteSpace: "nowrap" }}
                title={`Fresh Walk-in: ${freshWalkInCountState} | Repeated Walk-in: ${repeatedWalkInCountState}`}
              >
                <button className="outline-none inline-flex items-center gap-2 px-3 py-1 rounded-md border !border-orange-300 bg-orange-50 text-black text-sm font-medium cursor-pointer">
                  <UserOutlined />
                  <span>
                    Total Walk-in: <span className="font-semibold">{walkInCountState}</span>
                  </span>
                </button>
              </Tooltip>
            )}

            {canAddNew && (
              <button
                onClick={() => setVisible(true)}
                data-testid="add-new"
                className="btn btn-primary flex gap-[10px] items-center"
              >
                <PlusOutlined style={{ fontSize: "1.1rem", fontWeight: 600 }} />
                <span className="flex items-center text-[16px] font-semibold">
                  Add New
                </span>
              </button>
            )}
            {canExport && (
              <button
                disabled={
                  candidateList?.length === 0 || candidatesOrg?.length === 0
                }
                onClick={onClickDownloadCSV}
                data-testid="export"
                className={`btn ${candidateList?.length !== 0 || candidatesOrg?.length !== 0 ? "btn-primary" : "btn-secondary"}  flex gap-[10px] items-center`}
              >
                <ExportOutlined style={{ fontSize: "1.1rem", fontWeight: 600 }} />
                <span className="flex items-center text-[16px] font-semibold">
                  Export
                </span>
              </button>
            )}

            {isAmeyoActive && canExportToAmeyo && (
              <>
                <button
                  disabled={selectedRowKeys.length === 0}
                  onClick={exportToAmeyo}
                  data-testid="export-to-ameyo"
                  className={`btn ${selectedRowKeys.length > 0 ? "btn-success" : "btn-secondary"} flex gap-[10px] items-center`}
                >
                  <ExportOutlined style={{ fontSize: "1.1rem", fontWeight: 600 }} />
                  <span className="flex items-center text-[16px] font-semibold">
                    Export to Ameyo
                  </span>
                </button>
              </>
            )}
          </div>
        )}
      </div>
      <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
        <div className="w-100 d-flex filter-section my-2 justify-content-between">
          {load ? (
            <Skeleton.Button
              active={true}
              style={{ width: "240px" }}
              size={"small"}
              block={false}
            />
          ) : (
            <div className=" p-0">
              <DashboardTabs
                headerFilterStatus={headerFilterStatus}
                count={count}
                tabLayout={tabLayout}
                setHeaderFilterStatusHandler={setHeaderFilterStatusHandler}
                reminders={reminders}
              />
            </div>
          )}
          {headerFilterStatus !== "Reminder" && (
            <div className="d-flex filter-group-gap negative-margin">
              {isAmeyoActive && canViewStatus && (
                <div className="font-semibold text-sm">
                  Status: {ameyoCallCompletedState} out of {ameyoCallCompletedState + ameyoCallPendingState} completed
                </div>
              )}
              <div className="p-0 ">
                <div className="filter-group filter-width">
                  <span className="d-flex align-items-center">
                    <SearchOutlined />
                    <input
                      type="text"
                      value={search}
                      // onKeyPress="return event.charCode>=48 && event.charCode<=57"
                      className="w-100 outline-none ml-2"
                      placeholder="Search..."
                      onChange={(e) => {
                        setSearch(e.target.value?.trimStart());
                        if (e.target.value === "") {
                          setContactDelay("");
                          setInterviewType("");
                          setTrigger((prev) => !prev);
                          if (TAB !== "Application_Received") {
                            setHeaderFilterStatus(TAB);
                          }
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
              <div
                className="p-0"
                onClick={() => setAdvanceFilter(!advanceFilter)}
              >
                <button
                  // disabled={headerFilterStatus === "BulkUpload"}
                  className="bg-white filter-group filter-group-btn"
                >
                  <FilterFilled style={{ color: "black" }} />{" "}
                  {advanceappliedFilters > 0 &&
                    (isApplicationReceived
                      ? advanceappliedFilters
                      : isTrueExist && formId.length === 1
                        ? advanceappliedFilters - 1 > 0
                          ? advanceappliedFilters - 1
                          : ""
                        : advanceappliedFilters)}
                </button>
              </div>
              <div
                className="p-0"
                onClick={() => {
                  clearFilters();
                  setTrigger((prev) => !prev);
                  if (TAB !== "Application_Received") {
                    setHeaderFilterStatus(TAB);
                  }
                  setSearch("");
                  setContactDelay("");
                  setInterviewType("");
                  setAdvanceappliedFilters(0);
                }}
              >
                <button className="bg-white filter-group filter-group-btn">
                  <i
                    className="custom-black-text fa fa-rotate-left"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>
          )}
        </div>
        {load ? (
          <div className="w-100">
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <Skeleton.Input
              className="mb-2"
              active={true}
              size={"small"}
              block={true}
            />
            <div className="flex justify-content-end align-items-center mb-2">
              <div className="flex gap-2">
                <Skeleton.Button
                  active={true}
                  style={{ width: "170px" }}
                  size={"small"}
                  block={false}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {TAB === "Application_Received" &&
              headerFilterStatus === "Application_Received" && (
                <div className="w-100 d-flex mb-2 justify-content-between">
                  <div className=" p-0">
                    <Radio.Group
                      buttonStyle="solid"
                      borderRadius="10px"
                      style={{
                        width: "100%",
                        marginBottom: 5,
                        borderRadius: "10px",
                        display: "flex",
                      }}
                      value={contactDelay}
                      onChange={(e) => {
                        const setter = pageSetterMap[TAB];
                        if (setter) {
                          setter(1);
                        }
                        setContactDelay(e.target.value);
                        setTrigger((prev) => !prev);
                      }}
                    >
                      <Radio.Button className="flex-fill text-center" value="">
                        All (
                        {search.length >= 3 ? newCount || 0 : count?.totalCount || 0}
                        )
                      </Radio.Button>
                      <Radio.Button className="flex-fill text-center" value="1">
                        24 hrs Delayed (
                        {search.length >= 3
                          ? delaySubTabCount["1"] || 0
                          : count?.oneDayCount || 0}
                        )
                      </Radio.Button>
                      <Radio.Button className="flex-fill text-center" value="2">
                        48 hrs Delayed (
                        {search.length >= 3
                          ? delaySubTabCount["2"] || 0
                          : count?.twoDayCount || 0}
                        )
                      </Radio.Button>
                      <Radio.Button className="flex-fill text-center" value="3">
                        72 + hrs (
                        {search.length >= 3
                          ? delaySubTabCount["3"] || 0
                          : count?.threeDayPlusCount || 0}
                        )
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                </div>
              )}

            {TAB === "Application_Received" &&
              headerFilterStatus === "In_Process" && (
                <div className="w-100 d-flex mb-2 justify-content-between">
                  <div className=" p-0">
                    <Radio.Group
                      buttonStyle="solid"
                      style={{
                        width: "100%",
                        marginBottom: 5,
                        display: "flex",
                      }}
                      value={interviewType || documentation}
                      onChange={(e) => {
                        const value = e.target.value;
                        const setter = pageSetterMap[TAB];
                        if (setter) {
                          setter(1);
                        }
                        if (value === "Documentation Pending") {
                          setDocumentation(value);
                          setInterviewType("");
                        } else {
                          setInterviewType(value);
                          setDocumentation("");
                        }
                        setTrigger((prev) => !prev);
                      }}
                    >
                      <Radio.Button className="flex-fill text-center" value="">
                        All (
                        {search.length >= 3
                          ? inProcessCount || 0
                          : count?.totalCount || 0}
                        )
                      </Radio.Button>
                      {dynamicRounds?.length === 0 && load ? (
                        <Skeleton.Input
                          style={{ width: "225px" }}
                          active={true}
                          size={"default"}
                        />
                      ) : (
                        <>
                          {dynamicRounds.map((interview, index) => (
                            <Radio.Button
                              key={index}
                              className="flex-fill text-center"
                              value={interview}
                            >
                              {interview} (
                              {search.length >= 3
                                ? subTabCount[interview] || 0
                                : count?.[interview] || 0}
                              )
                            </Radio.Button>
                          ))}
                        </>
                      )}
                    </Radio.Group>
                  </div>
                </div>
              )}
            <div style={{ width: "100%" }}>
              {/* Selection summary bar */}
              {selectedRowKeys.length > 0 && (
                <div
                  style={{
                    background: "#e6f4ff",
                    border: "1px solid #91caff",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    marginBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "13px",
                  }}
                >
                  <span>
                    <strong>{selectedRowKeys.length}</strong> row
                    {selectedRowKeys.length > 1 ? "s" : ""} selected
                  </span>
                  <button
                    onClick={() => {
                      setSelectedRowKeys([]);
                      setSelectedRows([]);
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#1677ff",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    Clear selection
                  </button>
                </div>
              )}

              {headerFilterStatus === "Reminder" ? (
                <>
                  <ReminderSection
                    mobileCopyReminder={mobileCopyReminder}
                    reminders={reminders}
                    reminderPageNo={reminderPageNo}
                    setReminderPageNo={setReminderPageNo}
                    setMobileCopyReminder={setMobileCopyReminder}
                    setLogDate={setLogDate}
                    logDate={logDate}
                  />
                </>
              ) : (
                <>
                  <Table
                    columns={isAmeyoActive ? columns : columns.filter((col) => col.title !== "Schedule / Call Now")}
                    dataSource={candidateList}
                    rowSelection={
                      (isAmeyoActive && canExportToAmeyo &&
                      [
                        "Application_Received",
                        "In_Process",
                        "On Hold",
                        "Rejected",
                        "TalentPool",
                      ].includes(
                        TAB === "Application_Received"
                          ? headerFilterStatus
                          : TAB,
                      ))
                        ? {
                          selectedRowKeys,
                          onChange: (keys, rows) => {
                            setSelectedRowKeys(keys);
                            setSelectedRows(rows);
                          },
                          preserveSelectedRowKeys: true,
                        }
                        : undefined
                    }
                    pagination={{
                      total: getPagination() || 0,
                      pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                      showSizeChanger: false,
                      current: pages[TAB],
                      onChange: onChange,
                    }}
                    // onRow={(record) => ({
                    //   onClick: async () => {
                    //     getCandidate(record?.candidate,record?.key)
                    //   },
                    // })}
                    showSorterTooltip={false}
                    scroll={{ x: true }}
                    style={{ whiteSpace: "pre" }}
                    exportFileName="details"
                    size="small"
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
      <Modal
        width={1100}
        visible={visible}
        title="Add New Candidate"
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        footer={null}
      // footer={[
      //   <Button key="back" onClick={handleCancel}>
      //     Cancel
      //   </Button>,
      // ]}
      >
        <ContactCreator refresh={"refresh"} tab={TAB} />
      </Modal>
      <AdvanceFilters
        departments={departments}
        designations={designations}
        allSources={allSources}
        setAdvanceFilter={setAdvanceFilter}
        advanceFilter={advanceFilter}
        allQualification={allQualification}
        callMasters={callMasters}
        allTrfs={allTrfs}
        users={users}
        allPositions={allPositions}
        statusParameters={statusParameters}
        loadCandidates={loadCandidates}
        allJobTypes={allJobTypes}
        setLoad={setLoad}
        interviewRouds={interviewRouds}
        isAppliedFilterEnable={isAppliedFilterEnable}
        formNames={formNames}
        locations={locations}
        mapping={mapping}
        clearFilters={clearFilters}
        isAmeyoActive={isAmeyoActive}
      />
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(!isModalOpen)}
        footer={null}
        title={null}
        width={500}
        style={{ top: "2%" }}
        closable={false}
        className="p-0 float-right mr-2 custom_modal__"
      >
        <div style={{ paddingTop: loading ? "20px" : "0px" }}>
          <Skeleton
            active
            loading={loading}
            paragraph={{
              rows: 18,
            }}
          >
            <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white">
              <h5 className="modal-title text-white text-capitalize">
                {candidate?.name}
              </h5>
              <div className="custom_tag">
                {candidate?.RehireDetails &&
                  candidate?.RehireDetails?.length !== 0 && (
                    <Tag
                      icon={
                        candidate?.RehireDetails?.[0]?.can_hire_in_future
                          ?.toLowerCase()
                          ?.trim() === "yes" ? (
                          <CheckCircleOutlined />
                        ) : (
                          <WarningOutlined />
                        )
                      }
                      color={
                        candidate?.RehireDetails?.[0]?.can_hire_in_future
                          ?.toLowerCase()
                          ?.trim() === "yes"
                          ? "#87d068"
                          : "#cd201f"
                      }
                    >
                      Rehired
                    </Tag>
                  )}
              </div>
              <div className="text-white d-flex">
                <button
                  type="text"
                  disabled={record - 1 <= 0}
                  className={`${record - 1 <= 0 ? "text-muted" : "text-white"
                    } bg-transparent py-1 px-2 border-muted border border-3 rounded mr-2`}
                  onClick={() =>
                    getCandidate(candidatesOrg[index - 1], index - 1)
                  }
                >
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
                <button
                  type="text"
                  disabled={count <= record}
                  className={`${count <= record ? "text-muted" : "text-white"
                    } bg-transparent py-1 px-2 border-white border border-3 rounded me-2`}
                  onClick={() =>
                    getCandidate(candidatesOrg[index + 1], index + 1)
                  }
                >
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div className="modal-body">
              {/* <div className="mb-3 ">
                        <h4 className="summary-title ">
                          {" "}
                          <span>Summary</span>
                        </h4>
                      </div> */}
              <ul className="list-unstyled detail-list">
                <li className="mb-2">
                  Phone:{" "}
                  <span className="details-info">
                    +91 {candidate?.mobileNo}{" "}
                  </span>
                  <button
                    onClick={() => {
                      navigator.clipboard
                        .writeText(candidate?.mobileNo)
                        .then(() => {
                          setMobileCopy(true);
                          setEmailCopy(false);
                        });
                    }}
                    className="d-inline-flex bg-white ml-2 outline-none"
                  >
                    {mobileCopy ? (
                      <span className="mx-2">
                        <span className="text-success ms-2">
                          <span className="bg-success text-white d-inline-flex p-1 rounded-circle mr-2">
                            <CheckOutlined />
                          </span>
                          Copied
                        </span>
                      </span>
                    ) : (
                      <CopyOutlined />
                    )}
                  </button>
                </li>
                <li className="mb-2">
                  Email:{" "}
                  <span className="details-info">{candidate?.email}</span>
                  <button
                    onClick={() => {
                      navigator.clipboard
                        .writeText(candidate?.email)
                        .then(() => {
                          setEmailCopy(true);
                          setMobileCopy(false);
                        });
                    }}
                    className="d-inline-flex bg-white ml-2 outline-none"
                  >
                    {emailCopy ? (
                      <span className="mx-2">
                        <span className="text-success ms-2">
                          <span className="bg-success text-white d-inline-flex p-1 rounded-circle mr-2">
                            <CheckOutlined />
                          </span>
                          Copied
                        </span>
                      </span>
                    ) : (
                      <CopyOutlined />
                    )}
                  </button>
                </li>
                {/* <li className="mb-2">
                          Trf Name:{" "}
                          <span className="details-info text-decoration-underline">
                            {" "}
                            {candidate?.trf &&
                              `${candidate?.trf?.title}-${candidate?.trf?.department}-${
                                candidate?.trf?.location
                              }-${candidate?.trf?.processName}-${moment(candidate?.trf?.tat)
                                .utc()
                                .format("YYYY-MM-DD")}`}
                          </span>
                        </li> */}
                <li className="mb-2">
                  Resume:{" "}
                  {candidate?.resume?.originalname ? (
                    <>
                      <span
                        className="details-info"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={async (e) => {
                          // const pdfUrl = await getImage(candidate?.resume?.path);
                          // setResumeUrl(pdfUrl);
                          // setExt(
                          //   candidate?.resume?.path?.split(".").pop().toLowerCase()
                          // );
                          // setResumeModal(true);
                          const resumeUrl = `/doc/${encodeURIComponent(
                            candidate?.resume?.path,
                          )}`;
                          window.open(resumeUrl, "_blank");
                        }}
                      >
                        {candidate?.resume?.originalname}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-decoration-underline">
                        {candidate?.resume}
                      </span>
                    </>
                  )}
                  {candidate?.resume?.originalname ? (
                    <>
                      {candidate?.resume?.path
                        ?.split(".")
                        .pop()
                        .toLowerCase() === "pdf" && (
                          <span className="pdf-icon d-inline-flex ml-2 ">
                            <FilePdfOutlined style={{ fontSize: "1.4rem" }} />
                          </span>
                        )}
                      {WORDEXT.includes(
                        candidate?.resume?.path?.split(".").pop().toLowerCase(),
                      ) && (
                          <span className="word-icon d-inline-flex ml-2 ">
                            <FileWordOutlined style={{ fontSize: "1.4rem" }} />
                          </span>
                        )}
                      {IMGEXT.includes(
                        candidate?.resume?.path?.split(".").pop().toLowerCase(),
                      ) && (
                          <span className="img-icon d-inline-flex ml-2 ">
                            <FileImageOutlined style={{ fontSize: "1.4rem" }} />
                          </span>
                        )}
                    </>
                  ) : (
                    ""
                  )}
                </li>
                <li className="mb-2">
                  Video:{" "}
                  {candidate?.video?.originalname ? (
                    <>
                      <span
                        className="details-info"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={async (e) => {
                          // const pdfUrl = await getImage(candidate?.video?.path);
                          // setResumeUrl(pdfUrl);
                          // setExt(
                          //   candidate?.video?.path?.split(".").pop().toLowerCase()
                          // );
                          // setResumeModal(true);
                          const videoUrl = `/doc/${encodeURIComponent(
                            candidate?.video?.path,
                          )}`;
                          window.open(videoUrl, "_blank");
                        }}
                      >
                        {candidate?.video?.originalname}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-decoration-underline">
                        {candidate?.video}
                      </span>
                    </>
                  )}
                  {candidate?.video?.originalname ? (
                    <>
                      {VIDEXT.includes(
                        candidate?.video?.path?.split(".").pop().toLowerCase(),
                      ) && (
                          <span className="word-icon d-inline-flex ml-2 ">
                            <VideoCameraOutlined style={{ fontSize: "1.4rem" }} />
                          </span>
                        )}
                    </>
                  ) : (
                    ""
                  )}
                </li>
                {/* <li className="mb-2">
                  Applied for:{" "}
                  <span className="details-info text-decoration-underline">
                    {" "}
                    {candidate?.profile}
                  </span>
                </li> */}
                <li className="mb-2">
                  Department / Designation:{" "}
                  <span className="details-info">{candidate?.profile}</span>
                </li>
                <li className="mb-2">
                  Location:{" "}
                  <span className="details-info">
                    {" "}
                    {candidate?.preferred_location}
                  </span>
                </li>
                <li className="mb-2">
                  Qualification:{" "}
                  <span className="details-info">
                    {candidate?.qualification}{" "}
                  </span>
                </li>
                <li className="mb-2">
                  Language:{" "}
                  <span className="details-info">{candidate?.languages} </span>
                </li>
                {/* {candidate?.isNonAgent ? (
                  <> */}
                {candidate?.rounds?.map((inter) => {
                  return (
                    <li className="mb-2">
                      {inter?.name}:{" "}
                      <InterviewRoundsIndicator round={inter?.status} />
                    </li>
                  );
                })}
                {/* </>
                ) : (
                  <>
                    <li className="mb-2">
                      L1 Status:{" "}
                      <InterviewRoundsIndicator round={candidate?.L1_Status} />
                    </li>
                    <li className="mb-2">
                      L2 Status:{" "}
                      <InterviewRoundsIndicator round={candidate?.L2_Status} />
                    </li>
                    <li className="mb-2">
                      L3 Status:{" "}
                      <InterviewRoundsIndicator round={candidate?.L3_Status} />
                    </li>
                    <li className="mb-2">
                      Client Round:{" "}
                      <InterviewRoundsIndicator round={candidate?.L4_Status} />
                    </li>
                  </>
                )} */}
                <li className="mb-2">
                  Notice period:{" "}
                  <span className="details-info">
                    {" "}
                    {candidate?.noticePeriod ? candidate?.noticePeriod : ""}
                  </span>
                </li>
                <li className="mb-2">
                  Experience:{" "}
                  <span className="details-info">
                    {" "}
                    {candidate?.experience ? candidate?.experience : "No"}
                  </span>
                </li>
                <li className="mb-2">
                  CTC:{" "}
                  <span className="details-info">
                    {" "}
                    {candidate?.ctc ? candidate?.ctc : ""}
                  </span>
                </li>
                <li className="mb-2">
                  Age: <span className="details-info"> {candidate?.age}</span>
                </li>
              </ul>
              <div className="d-flex justify-content-between align-items-center">
                <div className="flex gap-2">
                  {/* <button
                    onClick={() => accepted(candidate?._id)}
                    className="bg-[#b7eb8f] px-3 py-2 rounded-lg text-[#52c41a]"
                  >
                    <strong>Proceed</strong>
                  </button> */}
                  {canProceed && (
                    <Tag
                      onClick={() => accepted(candidate?._id)}
                      style={{
                        padding: "5px",
                        width: "85px",
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: "6px",
                        fontWeight: "bold",
                      }}
                      color={"success"}
                    >
                      Proceed
                    </Tag>
                  )}

                  {canNotFit && TAB !== "Hired" &&
                    !candidate?.isDocumentSentToCandidate &&
                    candidate?.responses?.length !== 0 && (
                      <Tag
                        onClick={() => setNotFitPopup(true)}
                        style={{
                          padding: "5px",
                          width: "85px",
                          textAlign: "center",
                          cursor: "pointer",
                          borderRadius: "6px",
                          fontWeight: "bold",
                        }}
                        color={"error"}
                      >
                        Not Fit
                      </Tag>
                      // <button
                      //   onClick={() => setNotFitPopup(true)}
                      //   className="bg-[#ffccc7] text-[#ff4d4f] px-3 py-2 rounded-lg"
                      // >
                      //   <strong>Not Fit</strong>
                      // </button>
                    )}
                </div>
                {candidate?.RehireDetails &&
                  candidate?.RehireDetails?.length !== 0 && (
                    <span
                      className="details-info"
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontSize: "1rem",
                      }}
                      onClick={async (e) => {
                        setOpenRehireHistory(true);
                      }}
                    >
                      Rehiring History
                    </span>
                  )}
              </div>
            </div>
          </Skeleton>
        </div>
      </Modal>
      {notFitPopup && (
        <NotFitCandidate
          setNotFitPopup={setNotFitPopup}
          notFitPopup={notFitPopup}
          candidate={candidate}
          loadCandidates={loadCandidates}
          setIsModalOpen={setIsModalOpen}
          accepted={accepted}
          tab={TAB}
        />
      )}
      <Modal
        open={openRehireHistory}
        onCancel={() => setOpenRehireHistory(!openRehireHistory)}
        footer={null}
        title={"Rehiring History"}
        width={450}
        style={{ top: "9%", right: "33%" }}
        closable={true}
        className="p-0 float-right mr-2 custom_modal__"
      >
        <div className="modal-body">
          <ul className="list-unstyled detail-list">
            <li className="mb-2">
              Emp ID:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.emp_id || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Department:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.department || ""}
              </span>
            </li>
            <li className="mb-2">
              Reporting Manager:{" "}
              <span className="details-info text-decoration-underline">
                {candidate?.RehireDetails?.[0]?.reporting_manager || ""}
              </span>
            </li>
            <li className="mb-2">
              Date of Joining:{" "}
              <span className="details-info">
                {" "}
                {candidate?.RehireDetails?.[0]?.date_of_joining || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Date of Exist:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.date_of_exit || ""}
              </span>
            </li>
            <li className="mb-2">
              Process:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.process_name || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Release Date:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.released_date || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Manager Comments:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.manager_comment || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Separation Reason:{" "}
              <span className="details-info">
                {candidate?.RehireDetails?.[0]?.sepration_reason || ""}{" "}
              </span>
            </li>
            <li className="mb-2">
              Can Hire in Future:{" "}
              <span className="details-info">
                <strong>
                  {candidate?.RehireDetails?.[0]?.can_hire_in_future
                    ?.toLowerCase()
                    ?.trim() === "yes" ? (
                    <span style={{ color: "#87d068" }}>Yes</span>
                  ) : (
                    <span style={{ color: "#cd201f" }}>No</span>
                  )}
                </strong>
              </span>
            </li>
          </ul>
        </div>
      </Modal>
    </Dashboard>
  );
};

export default CandidateDashboard;
